import React from 'react'
import { ChatBubbleLeftRightIcon, ClipboardDocumentCheckIcon, ExclamationTriangleIcon, HomeIcon, InformationCircleIcon, ListBulletIcon, MapPinIcon, PencilSquareIcon, PlusIcon, QuestionMarkCircleIcon, TagIcon, UserPlusIcon, UsersIcon } from '@heroicons/react/24/outline';
import { Link } from 'gatsby';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { MosqueOutlined } from '@mui/icons-material';

const ICON_STYLE = "block h-6 w-6 flex-start";

const LINK_STYLE = "flex flex-row gap-4 p-4 no-underline"

export default function Sidebar() {
      const { user, setUser } = useAuthContext()
      return (

            <div className="sidebar pt-[4rem] lg:fixed w-full lg:w-[250px] flex flex-row lg:flex-col lg:flex-nowrap flex-wrap overflow-auto h-full shadow bg-gray-800 text-white">

                  <Link to="/admin/" className="flex flex-row gap-4 p-4 no-underline">
                        <HomeIcon className="block h-6 w-6 flex-start" />
                        <span className='flex-end'>Home</span>
                  </Link>
                  {user.role == 1 ? <>
                        <Link to="/admin/users" className="flex flex-row gap-4 p-4 no-underline">
                              <UsersIcon className="block h-6 w-6 flex-start" />
                              <span>Users</span>
                        </Link>

                        <Link to="/admin/users-requests" className="flex flex-row gap-4 p-4 no-underline">
                              <UserPlusIcon className="block h-6 w-6 flex-start" />
                              <span>Users Request</span>
                        </Link>

                        <Link to="/admin/certificates" className="flex flex-row gap-4 p-4 no-underline">
                              <ClipboardDocumentCheckIcon className="block h-6 w-6 flex-start" />
                              <span>Certificates</span>
                        </Link>
                  </>
                        : <></>}

                  <Link to="/admin/feedbacks" className="flex flex-row gap-4 p-4 no-underline">
                        <ChatBubbleLeftRightIcon className="block h-6 w-6 flex-start" />
                        <span>Feedbacks</span>
                  </Link>

                  <Link to="/admin/questions" className="flex flex-row gap-4 p-4 no-underline">
                        <InformationCircleIcon className="block h-6 w-6 flex-start" />
                        <span>Questions</span>
                  </Link>

                  <Link to="/admin/complaints" className="flex flex-row gap-4 p-4 no-underline">
                        <ExclamationTriangleIcon className="block h-6 w-6 flex-start" />
                        <span>Complaints</span>
                  </Link>

                  <Link to="/admin/checks" className="flex flex-row gap-4 p-4 no-underline">
                        <QuestionMarkCircleIcon className="block h-6 w-6 flex-start" />
                        <span>Checks</span>
                  </Link>

                  <Link to="/admin/applies" className="flex flex-row gap-4 p-4 no-underline">
                        <PlusIcon className="block h-6 w-6 flex-start" />
                        <span>Applies</span>
                  </Link>

                  <Link to="/admin/saudi-applications" className={`${LINK_STYLE}`}>
                  <MosqueOutlined fontSize='medium' className="flex-start" />
                        <span>Saudi Applications</span>
                  </Link>

                  <Link to="/admin/blog" className="flex flex-row gap-4 p-4 no-underline">
                        <PencilSquareIcon className="block h-6 w-6 flex-start" />
                        <span>Blog</span>
                  </Link>

            </div>

      )
}
